/* eslint-disable no-return-assign */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-danger-with-children */

// cleanup_convert_to_glu_component_LOGIN_WORKFLOW
// cleanup_hoc_to_hooks_LOGIN_WORKFLOW
// cleanup_class_to_function_LOGIN_WORKFLOW

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactToPrint from 'react-to-print';
import { connect } from 'react-redux';

import Alert from '@glu/alerts-react';
import { withStyles } from '@glu/theming';
import { PrinterIcon, EnvelopeDocumentIcon } from '@glu/icons-react';

import {
  getTsAndCs,
  emailTsAndCs,
  acceptTsAndCs,
  declineTsAndCs
} from 'api/termsAndConditions/service';
import { fetchUserData } from 'api/user/service';
import { clearGrids } from 'logic/store/grids/actions';
import { setCurrentUser, logout } from 'logic/store/authentication/actions';
import Fade from 'components/transitions/Fade';
import Modal from 'components/modal/Modal';
import PageHeader from 'components/pageHeader/PageHeader';
import Slide from 'components/transitions/Slide';
import { unsubscribeComponent } from 'components/utils/util';
import withLocale from 'components/withLocale/withLocale';
import { ALERTVARIATIONS } from 'constants.js';
import styles from './termsAndConditions.styles';

export class TermsAndConditionsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: '',
      termsAndCondtions: [],
      termsConditionsId: 0,
      termsConditionsMessage: '',
      termsConditionsName: '',
      show: true,
      sending: false,
      showDeclineMessage: false,
      successMessage: ''
    };

    this.subscriptions = {
      fetchUserData: null,
      acceptTerms: null,
      getTerms: null,
      emailTerms: null,
      declineTerms: null
    };
  }

  componentDidMount() {
    this.getTerms();
  }

  componentWillUnmount() {
    unsubscribeComponent(this.subscriptions);
  }

  getTerms() {
    this.subscriptions.getTerms = getTsAndCs().then(({ data: { termsAndCondtions } }) =>
      this.setState({
        show: true,
        sending: false,
        ...termsAndCondtions.pop(),
        errorMessage: '',
        successMessage: '',
        termsAndCondtions
      })
    );
  }

  setTerms() {
    this.setState(({ termsAndCondtions }) => ({
      show: true,
      sending: false,
      ...termsAndCondtions.pop()
    }));
  }

  refnames = {};

  clear = (item) => () => this.setState({ [item]: '' });

  close = (item) => () => this.setState({ [item]: false });

  open = (item) => () => this.setState({ [item]: true });

  email = () => {
    const {
      user: { customerCode, userCode }
    } = this.props;
    const { termsConditionsId, termsConditionsName } = this.state;
    const { locale } = this.props;

    this.subscriptions.emailTerms = emailTsAndCs({
      customerCode,
      userCode,
      termsConditionsId,
      termsConditionsName
    })
      .then(() => {
        this.setState({ successMessage: locale['termsAndConditions.emailed'] });
      })
      .catch(this.handleError);
  };

  print = () => {
    const { locale } = this.props;
    return (
      <button className="btn btn-link" type="button">
        <PrinterIcon />
        {locale['button.printDisclosure']}
      </button>
    );
  };

  printContent = () => this.refnames.terms;

  accept = () => {
    const {
      user: { customerCode, userCode }
    } = this.props;
    const { termsConditionsId, termsConditionsName } = this.state;

    this.setState({
      errorMessage: '',
      successMessage: '',
      sending: true
    });

    this.subscriptions.acceptTerms = acceptTsAndCs({
      customerCode,
      userCode,
      termsConditionsId,
      termsConditionsName
    })
      .then(this.accepted)
      .catch(this.handleError);
  };

  decline = () => {
    const {
      user: { customerCode, userCode }
    } = this.props;
    const { termsConditionsId, termsConditionsName } = this.state;

    this.subscriptions.declineTerms = declineTsAndCs({
      customerCode,
      userCode,
      termsConditionsId,
      termsConditionsName
    })
      .then(() => {
        this.props.clearGrids();
        this.props.logout();
      })
      .catch(this.handleError);
  };

  accepted = (data) => {
    if (!data.success) {
      throw new Error(data);
    }

    if (this.state.termsAndCondtions.length) {
      this.setTerms();
    } else {
      this.subscriptions.fetchUserData = fetchUserData(true).then((user) => {
        /** @description check if there are more terms to sign. */
        if (user.hasTermsAndConditions) {
          this.setState({ show: false });
          this.getTerms();
        } else {
          this.props.setCurrentUser(user);
        }
      });
    }
  };

  handleError = () => {
    const { locale } = this.props;
    this.setState({ sending: false, errorMessage: locale['common.server.error'] });
  };

  bindRef = (component) => {
    const { props = {} } = component || {};
    if (!props.refname) {
      return;
    }
    this.refnames[props.refname] = component;
  };

  render() {
    const {
      classes: { content, header, innerContent },
      locale,
      pageStyle
    } = this.props;

    const {
      errorMessage,
      sending,
      show,
      showDeclineMessage,
      successMessage,
      termsConditionsMessage,
      termsConditionsName
    } = this.state;

    return (
      <div className="glu-content row">
        <PageHeader title={locale['common.terms.conditions']} />
        <div className={innerContent}>
          <Fade in={show}>
            <div>
              {errorMessage && (
                <Alert
                  dataQa="termsError"
                  id="loginFormError"
                  message={errorMessage}
                  onHide={this.clear('errorMessage')}
                  variant={ALERTVARIATIONS.ERROR}
                />
              )}

              {successMessage && (
                <Alert
                  dataQa="termsSuccess"
                  id="loginFormSuccess"
                  message={successMessage}
                  onHide={this.clear('successMessage')}
                  variant={ALERTVARIATIONS.SUCCESS}
                />
              )}

              <header className={classnames(header, 'col-12')}>
                <div className="pull-right">
                  <button
                    className="btn btn-link"
                    data-qa="email-terms"
                    disabled={sending}
                    onClick={this.email}
                    type="button"
                  >
                    <EnvelopeDocumentIcon />
                    {locale['button.emailDisclosure']}
                  </button>
                  <ReactToPrint
                    content={() => this.termsContetntRef}
                    disabled={sending}
                    pageStyle={pageStyle}
                    trigger={this.print}
                  />
                </div>
                <h2>{termsConditionsName}</h2>
              </header>

              <article className="col-12 form-group">
                <div className={classnames(content, 'form-control')}>
                  <span
                    ref={(el) => (this.termsContetntRef = el)}
                    dangerouslySetInnerHTML={{ __html: termsConditionsMessage }}
                  />
                </div>
              </article>
            </div>
          </Fade>

          <footer className="col-12 form-group">
            <div className="pull-right">
              <button
                className="btn btn-secondary"
                disabled={sending}
                onClick={this.open('showDeclineMessage')}
                type="button"
              >
                {locale['button.declineDisclosure']}
              </button>
              <button
                className="btn btn-primary"
                data-qa="accept-terms"
                disabled={sending}
                onClick={this.accept}
                type="button"
              >
                {locale['button.acceptDisclosure']}
              </button>
            </div>
          </footer>
        </div>
        <Modal
          header={locale['common.terms.conditions']}
          onHide={this.close('showDeclineMessage')}
          show={showDeclineMessage}
          transition={Slide}
        >
          {showDeclineMessage && (
            <div className="form-group">
              <div className="form-group">
                <p>{locale['termsAndConditions.acceptRequired']}</p>
              </div>
              <div className="form-group">
                <p>{locale['termsAndConditions.confirmDecline']}</p>
              </div>

              <div className="form-group">
                <button className="btn btn-primary" onClick={this.decline}>
                  {locale['termsAndConditions.declineDisclosure']}
                </button>
                <button className="btn btn-link" onClick={this.close('showDeclineMessage')}>
                  {locale['termsAndConditions.cancel']}
                </button>
              </div>
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (...params) => dispatch(setCurrentUser(...params)),
  logout: (...params) => dispatch(logout(...params)),
  clearGrids: () => clearGrids(dispatch)
});

TermsAndConditionsComponent.defaultProps = {
  classes: {},
  locale: {},
  clearGrids() {},
  logout() {},
  setCurrentUser() {},
  pageStyle:
    '@page { size: auto; margin: 12mm; } @media print { body { -webkit-print-color-adjust: exact; } }',
  user: {}
};

TermsAndConditionsComponent.propTypes = {
  classes: PropTypes.shape({}),
  locale: PropTypes.shape({}),
  clearGrids: PropTypes.func,
  logout: PropTypes.func,
  setCurrentUser: PropTypes.func,
  pageStyle: PropTypes.string,
  user: PropTypes.shape({
    userCode: PropTypes.string,
    customerCode: PropTypes.string
  })
};

const TermsAndConditionsComponentConnect = connect(
  null,
  mapDispatchToProps
)(TermsAndConditionsComponent);
const LocaleTermsAndConditions = withLocale(TermsAndConditionsComponentConnect);
export default withStyles(styles)(LocaleTermsAndConditions);
